import { gql } from "apollo-angular";
import { LegalEntityFilters } from "../../models/legal-entity.model";
import { LEGAL_FIELD } from "./legal.enum";
import { OrderingType } from "../../../features/administration/legal-entities/legal-entities.component";
import { buildStringSchema, buildSearchSchema } from "../graph-ql.operations";

export const LEGAL_TABLE_FRAGMENT = gql`
  fragment LegalTableData on LegalEntity {
    auditControlApproach
    businessType
    businessUnit
    category
    chiefAuditor
    endDate
    id
    lastTaxonomyCampaignCompletionDate
    lastTaxonomyCampaignStartingDate
    lastUpdated
    legalEntityCode
    legalEntityName
    legalEntitySize
    legalEntityTrackingId
    macroBusinessUnit
    organizationalUnit
    startDate
    status
    valueChain
  }
`;
export const PAGINATED_LEGAL_FRAGMENT = gql`
  fragment PaginatedLegalFragment on LegalEntitiesQueryResponse {
    pageSize
    pageIndex
    totalPages
    totalElements
  }
`;

// query MyQuery {
//     legalEntitiesByFilters(
//       page: {pageSize: 1000, pageNo: 0}
//       query: [
//         {
//         field: ENTITY_NAME,
//         filters: {
//           value:"Generali",order:DESC, operator: CONTAINS
//          }
//         },

//       ]
//     ) {

//
export const LEGAL_TABLE_QUERY = (
  filters: LegalEntityFilters,
  search: string,
  manageScope: boolean,
  order?: OrderingType
) => gql`
    query GetLegalEntities($page:PagingInput, $direction: OrderTypeInput, $sortField: LegalEntityFields, $manageScope: Boolean) {
        legalEntitiesByQueryComplex(
          query: { 
            operator: AND, 
            query: [
              { 
                query: [
                  ${buildStringSchema(filters, LEGAL_FIELD)}
                ] 
              }, 
              ${search && search !== '' ? `
                { 
                  operator: OR, 
                  query: [
                    ${buildSearchSchema(search, [
  "AUDIT_CONTROL_APPROACH",
  "BUSINESS_TYPE",
  "CATEGORY",
  "CHIEF_AUDITOR",
  "END_DATE",
  "LAST_TAXONOMY_CAMPAIGN_COMPLETION_DATE",
  "LAST_TAXONOMY_CAMPAIGN_STARTING_DATE",
  "START_DATE",
  "VALUE_CHAIN",
  "LAST_UPDATED",
  "LEGAL_ENTITY_TRACKING_ID",
  "BUSINESS_UNIT",
  "ORGANIZATIONAL_UNIT",
  "LEGAL_ENTITY_CODE",
  "LEGAL_ENTITY_NAME",
  "LEGAL_ENTITY_SIZE",
  "MACRO_BUSINESS_UNIT",
  "END_DATE",
  "STATUS"
]) ?? ""}
                  ] 
                }
                ` : ''
  }
              
            ] 
          }
          page: $page
          sort:{ sortOrder: $direction , sortField: $sortField }
          manageScope: $manageScope
        ){
            ...PaginatedLegalFragment
            data{
                ...LegalTableData
            }
        }
    }
    ${PAGINATED_LEGAL_FRAGMENT}
    ${LEGAL_TABLE_FRAGMENT}
`;

export const LEGAL_TABLE_NAMES = (...names: string[]) => gql`
    query {
        legalEntitiesByQueryComplex(
          query: { operator: AND, query: [{ query: [] }] }
          page:  {pageSize: 10000000, pageNo:0}
          sort:{ sortOrder: ASC , sortField: ID }
        ) {
          ...PaginatedLegalFragment
          data {
            ...LegalTableData
            __typename
          }
          __typename
        }
    }
    ${PAGINATED_LEGAL_FRAGMENT}
    ${LEGAL_TABLE_FRAGMENT}

`;

export const GET_LEGAL_ENTITIES_TABLE = gql`
  query {
    legalEntitiesByQueryComplex(
      query: { operator: AND, query: [{ query: [] }] }
      page:  {pageSize: 10000000, pageNo:0}
      sort:{ sortOrder: ASC , sortField: ID }
    ) {
      ...PaginatedLegalFragment
      data {
        ...LegalTableData
        __typename
      }
      __typename
    }
  }
  ${PAGINATED_LEGAL_FRAGMENT}
  ${LEGAL_TABLE_FRAGMENT}
`;

export const EXPORT_LEGAL_ENTITIES = (
  filters: LegalEntityFilters,
  search: string
) => gql`
  mutation exportLegalEntities ($direction: OrderTypeInput, $sortField: LegalEntityFields){
    downloadLegalEntitiesByQuery(
      query:[
          ${buildStringSchema(filters, LEGAL_FIELD)}
          ${buildSearchSchema(search, ["LEGAL_ENTITY_CODE", "LEGAL_ENTITY_NAME", "LEGAL_ENTITY_SIZE"]) ?? ""} 
      ]
      sort:{ sortOrder: $direction , sortField: $sortField }
    ) {
      data {
        content
        filename
      }
    }
  }
`;
export const SYNCRONIZE_LEGAL_ENTITIES = () => gql`
  mutation syncronizeLegalEntities{
    batchExecutionLegalEntities {
      data
      message
      statusCode
    }
  }
`;
